import React, { useContext, useEffect, useRef } from 'react'
import { NavigationContext } from '../context/NavigationContext'
import Card from './Card'
import MenuItem from './MenuItem'
import LinkItem from './LinkItem'

const MenuMobile = () => {
    const { pages, menuVisible, setMenuVisible } = useContext(NavigationContext)
    const node = useRef();

    const handleClickOutside = e => {
        if (!node.current.contains(e.target)) {
            setMenuVisible();
        }
    }

    useEffect(() => {
        if (menuVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuVisible])

    if (menuVisible) {
        return (
            <div className="menu-mobile">
                <div className="menu-mobile-container" ref={node}>
                    <Card size="medium">
                        <h3>Menu</h3>
                        {Object.keys(pages).map(item => <MenuItem currentPage={pages[item]} key={pages[item].uri} />)}
                    </Card>
                    <Card size="medium">
                        <h3>Liens utiles</h3>
                        <LinkItem key="moodle" to="https://moodle.utc.fr/course/search.php?search=nf05" icon="moodle">Moodle NF05</LinkItem>
                        <LinkItem key="pix" to="https://pix.fr/" icon="pix">Site de Pix</LinkItem>
                        <LinkItem key="utc" to="https://www.utc.fr" icon="utc">Site de l'UTC</LinkItem>
                    </Card>
                </div>
            </div>
        );
    } else {
        return (<></>)
    }
}

export default MenuMobile;